// services/stripeService.js
const STORE_API_URL = process.env.REACT_APP_API_URL;

export const createStripeAccount = async (token) => {
  const response = await fetch(`${STORE_API_URL}/stripe/account`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`, // Use user's auth token
    },
  });

  if (!response.ok) {
    throw new Error('Error creating Stripe account');
  }

  const data = await response.json();
  return data.account; // Return the account ID
};

export const createAccountLink = async (token, accountId) => {
  const response = await fetch(`${STORE_API_URL}/stripe/account_link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ account: accountId }),
  });

  if (!response.ok) {
    throw new Error('Error creating account link');
  }

  const data = await response.json();
  return data;
};

export const updateAccountLink = async (token) => {
  const response = await fetch(`${STORE_API_URL}/stripe/account_link`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    }
  });

  if (!response.ok) {
    throw new Error('Error creating account link');
  }

  const data = await response.json();
  return data;
};
